import {LaborAutofillStaffingRuleModel} from '../core/_models'

/**
 * What the auto-fill result says about the Staffing Rules page.
 *
 * Only the broken rules are listed — a week that keeps eleven of twelve rules
 * should read as one thing to look at — but the count of the ones checked is
 * kept, because "all 12 held" and "no rules configured" must not look alike.
 */
export const summarizeStaffingRules = (
  rules: LaborAutofillStaffingRuleModel[] | undefined
): {checked: number; broken: LaborAutofillStaffingRuleModel[]} => {
  const all = rules || []
  return {
    checked: all.length,
    broken: all.filter((rule) => !rule.passed).sort((a, b) => b.cost - a.cost),
  }
}
